/**
 * 批量预约提货 组件
 * 勾选 多个订单 批量预约提货
 * 显示订单号及订单信息及 图片列表
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param onChangeOne 响应选择
 *
 **/
import React from "react";
import dayjs from 'dayjs';
import { Checkbox, Empty, } from 'antd';
import './stepOne.less'
import {toFixedWithCommas} from "@/utils/number-util";
import Lang from "@components/Lang/Lang";
import PicturePreview from '@components/PicturePreview/PicturePreview';
export default class StepOne extends React.Component{
    static defaultProps = {
        inStoragePoList:[], //入库PO单列表
        payAmountPoList:[], // 已支付尾款列表
        arrivalPortDate: "", // 预计到达日期 number
        selectObj:{},
        type: 1, // 1 : 第一步勾选内容, 2: 准备预约的订单内容
    };
    onChange(checked,id){
        let { selectObj={}} = this.props;
        selectObj[id] = checked;
        // this.setState({
        //     selectObj:selectObj
        // })
        if(this.props.onChangeOne)this.props.onChangeOne(selectObj)
    }
    // 渲染
    renderOne(model={},inx=0,selectObj={},type=1){
        return (<div className={`item flex-item-ver-center${selectObj[model.poId]?" selectItem":""}`} key={"por_"+inx}>
            {type!=2?<Checkbox checked={selectObj[model.poId]} onChange={(e)=>this.onChange(e.target.checked,model.poId)} />:null}
                <div className={"ml_8 flex1"}>
                    <div>
                        <p className={"fw_700 black89 font_16"}>{model.poCode}</p>
                        {/* 总计 9 箱, 24 款 */}
                        <p className={"font_12 mt_4"}>
                            {__getServerLanguage("ZongJi")}{__getServerLanguage('NKuanNXiang',model.totalCount,model.totalQuantity)}，
                            {toFixedWithCommas(model.totalVolume,3)||'-'} m³，
                            {toFixedWithCommas(model.totalGrossWeight,3)||'-'} kg，
                            {/*订单送至*/}
                            <span>{__getServerLanguage("DingDanSongZhi")}</span>
                            {model.transitCityName}
                            <span>{__getServerLanguage("CangKu")}</span>
                        </p>
                    </div>
                    {/* 商品图片列表 不包括取消商品   */}
                    {model.poItemSkuFileUrlList&&model.poItemSkuFileUrlList.length>0&&<PicturePreview
                        list={model.poItemSkuFileUrlList}
                        size={80}
                        styleName={"bookPickPicturePreview"} />}
                    {/*{model.poItemSkuFileUrlList&&model.poItemSkuFileUrlList.length>0&&<PicturePreview list={model.poItemSkuFileUrlList}*/}
                                                                                                      {/*moreNum={5}*/}
                                                                                                      {/*total={model.poItemSkuFileUrlList.length}*/}
                                                                                                      {/*size={80} />}*/}
                </div>
        </div>)
    }
    handleOk(){
        const { selectObj } = this.props;
        let poIds = [];
        for(let key in selectObj){
            if(selectObj[key])poIds.push(key)
        }
        return poIds
    }
    // 全选 或者 取消全选
    onSelectAll(flag=false){
        const { selectObj={}, payAmountPoList=[],} = this.props;
        payAmountPoList.forEach(item=>{
            selectObj[item.poId] = flag;
        })
        // this.setState({
        //     selectObj:selectObj
        // })
        if(this.props.onChangeOne)this.props.onChangeOne(selectObj)
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    render() {
        const {selectObj, payAmountPoList,inStoragePoList,arrivalPortDate,type} = this.props;
        return (type==2?<div className={"batchPickStepOne black66"}>
                    <p className={"black89 mb_4"}>
                        {Lang({id:"ZhunBeiYuYueDeDingDan",default:"准备预约的订单"})}
                    </p>
                    {inStoragePoList.map((item,inx)=>this.renderOne(item,inx,selectObj,type))}
                </div>:<div className={"batchPickStepOne black66"}>
                    <p className={"black89 mb_14 fw_700 font_20"}>
                        {Lang({id:"YuYueTiHuo",default:"预约提货"})}
                    </p>
                    {/*以下订单已入库，请尽快预约提货 */}
                    {inStoragePoList&&inStoragePoList.length>0?<div className={"listBox"}>
                        <p className={"black89 mb_4"}>
                            {Lang({id:"YiXiaDingDanYiRuKu",default:"以下订单已入库，请尽快预约提货"})}
                        </p>
                        {inStoragePoList.map((item,inx)=>this.renderOne(item,inx,selectObj,type))}
                    </div>:((!payAmountPoList||payAmountPoList.length==0)?<Empty
                        description={__getServerLanguage('WeiZhaoDaoFuHeTiaoJianDeJiLu')}
                        description={Lang({id:"WeiZhaoDaoFuHeTiaoJianDeJiLu",default:"以下订单已入库，请尽快预约提货"})}
                    />:null)}

                    {/* 以下订单已支付尾款，正在运输中，预计 2023-6-21 到达，是否要一起预约？ */}
                    {payAmountPoList&&payAmountPoList.length>0&&<>
                        <p className={"black89"}>
                            {Lang({id:"YiXiaDingDanYiZhiFuWeiKuan",
                                default:"以下订单已支付尾款，正在运输中，预计 {0} 到达，是否要一起预约？",
                                params:[arrivalPortDate?dayjs(arrivalPortDate).format("YYYY-MM-DD"):'-']})}
                        </p>
                        {/* 全选 取消全选 */}
                        <p className={"black89 font_12 mt_4 mb_4"}>
                            <span className={"color-blue cursor-p"} onClick={()=>this.onSelectAll(true)}>{__getServerLanguage("QuanXuan")}</span>
                            <span className={"ml_16 color-blue cursor-p"} onClick={()=>this.onSelectAll(false)}>{__getServerLanguage("QuXiaoQuanXuan")}</span>
                        </p>
                        {payAmountPoList.map((payItem,inx)=>this.renderOne(payItem,inx,selectObj,type))}
                    </>}
            </div>);
    }
}

